<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<div *ngIf="!loading">

  <!-- Header -->
  <div class="gt-header mb-4">
    <a class="gt-back-btn" [routerLink]="['/', langSrcSrv.current.shortCode, 'learning', 'dashboard']">
      <i class="fa-solid fa-arrow-left"></i>
      <span translate>Tableau de bord</span>
    </a>
    <div class="gt-header-center">
      <h2 class="gt-page-title" translate>Thématiques</h2>
    </div>
    <div class="gt-header-spacer"></div>
  </div>

  <!-- Grid -->
  <div class="row" *ngIf="data">
    <div class="col-12 col-md-6 col-lg-4 mb-4"
      *ngFor="let theme of data.themes | sortBy:'position'; trackBy: trackById"
      (click)="navigateToTheme(theme)">

      <div class="gt-card h-100">

        <div class="gt-img-wrap">
          <img *ngIf="!theme.image"
            src="assets/images/monuments/{{langTgtSrv.current.code}}.png"
            class="gt-img" alt="" />
          <img *ngIf="theme.image"
            [src]="theme.image | gameImage"
            class="gt-img" alt="" />
        </div>

        <div class="gt-info">
          <div class="gt-name">{{ theme.translation }}</div>
          <div class="gt-progress-row">
            <div class="gt-progress-track">
              <div class="gt-progress-fill" [style.width.%]="theme.avgScore > 0 ? theme.avgScore : 0"></div>
            </div>
            <span class="gt-progress-label">{{ theme.avgScore > 0 ? theme.avgScore : 0 }}%</span>
          </div>
          <span class="gt-badge gt-badge-resume" *ngIf="theme.avgScore > 0" translate>
            <i class="fa-solid fa-play"></i> Reprendre
          </span>
          <span class="gt-badge gt-badge-start" *ngIf="theme.avgScore === 0" translate>
            <i class="fa-solid fa-play"></i> Commencer
          </span>
        </div>

      </div>

    </div>
  </div>

</div>
